import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import TransactionList from "ui/organizms/TransactionList";

const TransactionListScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Transactions'

    >
        <TransactionList />
    </Screen>
);

export default memo(TransactionListScreen);
